export const WaverezLogo = ({ className }: { className?: string }) => (
    <svg
        className={className || ''}
        width="263"
        height="43"
        viewBox="0 0 263 43"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M36.5802 6.45996C39.8093 9.73009 41.8718 13.9475 42.4562 18.4753C43.0406 23.0031 42.1151 27.5955 39.8195 31.5589C39.8195 31.5589 34.1289 26.6689 32.1047 21.0357C30.0806 15.4024 32.3502 13.5457 32.3502 13.5457C32.3502 13.5457 33.8453 13.7757 34.1718 14.8057C34.1718 14.8057 35.09 14.2985 35.2336 13.2443C35.3797 12.1658 35.2717 11.0656 34.1289 9.768C34.1289 9.768 33.7729 8.16905 34.5695 7.26246C35.1759 6.56527 36.5802 6.45996 36.5802 6.45996Z"
            fill="#F1F6F7"
        />
        <path
            d="M26.3252 0.754384L26.4173 0.721703C22.4338 -0.247895 18.2511 -0.0628813 14.3716 1.25452C10.4921 2.57193 7.08077 4.9657 4.54734 8.14834C2.01392 11.331 0.466104 15.1671 0.0898165 19.1961C-0.286472 23.225 0.524764 27.2754 2.42609 30.8608C12.0238 5.11063 26.3252 0.754384 26.3252 0.754384Z"
            fill="#F1F6F7"
        />
        <path
            d="M42.7789 7.83625C42.7789 7.83625 44.9061 2.23813 37.4258 0.432203C28.5081 -1.7199 18.8171 4.29582 11.1785 15.5623C11.1785 15.5623 17.6842 8.4814 25.3793 7.51429C28.7094 7.0967 31.6149 7.45013 34.1386 9.76806C34.1386 9.76806 34.9659 7.71037 37.5756 6.89214C40.1852 6.0739 41.8435 6.59196 42.7789 7.83625Z"
            fill="url(#paint0_linear_479_23990)"
        />
        <path
            d="M34.3569 14.0603C34.3569 14.0603 36.2963 10.4098 30.8451 8.59414C25.6418 6.86326 18.3824 9.68351 13.4148 15.048C8.44714 20.4125 5.31337 26.4258 4.23073 29.0403C4.23073 29.0403 9.19468 21.0771 16.157 20.8846C22.9216 20.6982 22.1901 25.2518 21.4241 25.7783C21.4241 25.7783 19.988 23.7206 17.7245 25.9925C15.461 28.2645 15.504 34.0187 20.161 37.7964C24.8181 41.5741 28.4318 42.9903 28.4318 42.9903C28.4318 42.9903 34.1556 42.9999 39.7051 39.986C39.7051 39.986 32.0885 35.9917 28.2575 30.3706C24.4265 24.7494 24.7752 17.1941 28.2146 14.2722C31.654 11.3502 34.3569 14.0603 34.3569 14.0603Z"
            fill="url(#paint1_linear_479_23990)"
        />
        <path
            d="M21.385 24.834C21.385 24.834 21.973 20.8009 15.2586 21.5659C7.99558 22.3926 3.66992 32.3881 3.66992 32.3881C3.66992 32.3881 10.3278 43.3762 27.7839 42.9901C27.7839 42.9901 16.205 38.4402 15.7263 31.1862C15.2476 23.9323 20.4717 23.804 21.385 24.834Z"
            fill="url(#paint2_linear_479_23990)"
        />
        <path
            d="M32.3551 13.5459C32.3551 13.5459 28.853 26.0131 44.1745 36.2265C44.1745 36.2265 41.6263 38.9123 39.9716 39.7282C39.9716 39.7282 26.0863 32.3023 25.9991 22.4302C25.912 12.5582 32.3551 13.5459 32.3551 13.5459Z"
            fill="url(#paint3_linear_479_23990)"
        />
        <path
            d="M88.2037 12.0326L81.4604 23.5497L76.7391 15.4792L73.5809 10.083L70.4259 15.4634L65.7464 23.4547L59.0576 12.0326H52.7637L62.6042 28.8351L65.7592 34.2313L68.9014 28.8509L73.5809 20.8595L78.3022 28.93L81.4604 34.323L84.6154 28.9427L94.5073 12.0326H88.2037Z"
            fill="#F1F6F7"
        />
        <path
            d="M116.859 12.0894V14.7669C115.705 13.5943 114.322 12.6638 112.795 12.0313C111.267 11.3988 109.625 11.0773 107.968 11.0861C101.257 11.0861 95.8135 16.2956 95.8135 22.7045C95.8135 29.1134 101.27 34.3229 107.968 34.3229C109.623 34.3304 111.263 34.0083 112.789 33.3758C114.315 32.7433 115.696 31.8135 116.849 30.6421V33.7152H122.867V12.0894H116.859ZM109.624 29.93C105.343 29.93 101.87 26.6954 101.87 22.7045C101.87 18.7136 105.333 15.4917 109.615 15.4917C112.917 15.4917 115.751 17.4159 116.849 20.1314V25.2902C116.247 26.6831 115.239 27.868 113.953 28.6942C112.666 29.5204 111.159 29.9506 109.624 29.93Z"
            fill="#F1F6F7"
        />
        <path
            d="M146.268 12.0322L139.605 23.4164L132.932 12.0322H126.532L136.395 28.8885L139.605 34.3606L142.814 28.8759L152.681 12.0322H146.268Z"
            fill="#F1F6F7"
        />
        <path
            d="M175.077 25.8476C173.793 27.8004 171.225 29.6455 168.227 29.6455C163.984 29.6455 160.602 27.889 160.602 23.4644H179.361C179.378 23.2176 179.403 22.9739 179.403 22.7239C179.403 16.2136 174.05 10.9346 167.05 10.9346C160.05 10.9346 154.375 16.2136 154.375 22.7239C154.375 29.2341 160.05 34.5131 167.05 34.5131C172.223 34.5131 176.678 31.6267 178.636 27.4965L175.077 25.8476ZM167.319 15.511C170.352 15.511 172.811 17.0777 172.811 19.5526H161.545C162.001 16.7738 164.286 15.511 167.319 15.511Z"
            fill="#F1F6F7"
        />
        <path
            d="M226.081 25.8476C224.797 27.8004 222.229 29.6455 219.235 29.6455C214.992 29.6455 211.609 27.889 211.609 23.4644H230.369C230.385 23.2176 230.407 22.9739 230.407 22.7239C230.407 16.2136 225.057 10.9346 218.057 10.9346C211.057 10.9346 205.379 16.2136 205.379 22.7239C205.379 29.2341 211.053 34.5131 218.057 34.5131C223.227 34.5131 227.669 31.6267 229.64 27.4965L226.081 25.8476ZM218.323 15.511C221.359 15.511 223.818 17.0777 223.818 19.5526H212.533C212.989 16.7738 215.274 15.511 218.307 15.511H218.323Z"
            fill="#2EDFF1"
        />
        <path
            d="M197.515 10.6024C195.182 10.7955 193.413 12.2957 192.255 13.6787V11.3114H186.23V33.1904H192.248V19.3091C193.028 17.6507 194.155 16.0239 195.689 15.5112C199.22 14.3339 201.094 16.2708 201.094 16.2708L203.8 12.1184C203.8 12.1184 201.948 10.2385 197.515 10.6024Z"
            fill="#2EDFF1"
        />
        <path
            d="M261.065 28.5594V33.465H232.737L237.712 28.5594L250.618 15.8333H237.057V10.915H263L258.013 15.8333L245.094 28.5594H261.065Z"
            fill="#2EDFF1"
        />
        <defs>
            <linearGradient
                id="paint0_linear_479_23990"
                x1="6.79121"
                y1="-3.34821"
                x2="6.69293"
                y2="42.9909"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#2EDFF1" />
                <stop offset="1" stopColor="#13BAEB" />
            </linearGradient>
            <linearGradient
                id="paint1_linear_479_23990"
                x1="6.79121"
                y1="-3.34821"
                x2="6.69293"
                y2="42.9909"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#2EDFF1" />
                <stop offset="1" stopColor="#13BAEB" />
            </linearGradient>
            <linearGradient
                id="paint2_linear_479_23990"
                x1="6.79121"
                y1="-3.34821"
                x2="6.69293"
                y2="42.9909"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#2EDFF1" />
                <stop offset="1" stopColor="#13BAEB" />
            </linearGradient>
            <linearGradient
                id="paint3_linear_479_23990"
                x1="6.79121"
                y1="-3.34821"
                x2="6.69293"
                y2="42.9909"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#2EDFF1" />
                <stop offset="1" stopColor="#13BAEB" />
            </linearGradient>
        </defs>
    </svg>
);
